import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AppProvider } from "./context/AppContext";

import "./App.css";

// Pages
import Home from "./pages/Home";
import SongsHome from "./pages/SongsHome";
import SongSheet from "./pages/SongSheet";
import CreateSongSheet from "./pages/CreateSongSheet";
import EditSongSheet from "./pages/EditSongSheet";
import { DebugProvider } from "./context/DebugContext";

function App() {
  console.log(
    `You are running this application in ${process.env.NODE_ENV} mode.`
  );
  return (
    <AppProvider>
      <DebugProvider>
        <div>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/songs/" element={<SongsHome />} />
            <Route path="/songs/:id" element={<SongSheet />} />
            <Route path="/songs/create" element={<CreateSongSheet />} />
            <Route path="/songs/edit/:id" element={<EditSongSheet />} />
          </Routes>
          <ToastContainer position="bottom-right" />
        </div>
      </DebugProvider>
    </AppProvider>
  );
}

export default App;
